import type { GlobalTranslations } from "../interfaces/global";

export const globalTranslations: GlobalTranslations = {
  two_factor_required_generic: "Activa la autenticación en dos pasos para continuar",
  two_factor_required_modal_title: "Autenticación en dos pasos requerida",
  two_factor_required_modal_cancel: "Cancelar",
  two_factor_required_modal_go_to_settings: "Ir a configuración",
  two_factor_challenge_title: "Verifica tu identidad",
  two_factor_challenge_description:
    "Ingresa el código de 6 dígitos de tu app de autenticación para continuar.",
  two_factor_challenge_submit: "Verificar",
  two_factor_challenge_error_invalid_code: "Código incorrecto. Inténtalo de nuevo.",
  input_error_invalid_email: "Ingresa un correo válido.",
  input_error_required: "Este campo es requerido",
  input_error_min_length: "Este campo debe tener al menos {{length}} caracteres",
  input_error_max_length: "Este campo debe tener como máximo {{length}} caracteres",
  input_error_min_items: "Debe tener al menos {{items}} elementos",
  input_error_max_items: "Debe tener como máximo {{items}} elementos",
  input_error_min_value: "Debe ser mayor o igual a {{min}}",
  input_error_max_value: "Debe ser menor o igual a {{max}}",
  input_error_too_small: "El valor mínimo es {{min}}",
  input_error_too_big: "El valor máximo es {{max}}",
  input_error_invalid_url: "Ingresa una URL válida",
  input_error_invalid_uuid: "Identificador inválido",
  input_error_invalid_format: "El formato no es válido",
  input_error_invalid_value: "El valor no es válido",
  logout: "Cerrar sesión",
  input_error_phone_indicative_required: "El indicativo es requerido",
  input_error_phone_required: "El número de télefono es requerido",
  input_error_phone_invalid: "El número de télefono no tiene un formato válido para el país seleccionado",
  input_error_register_code: "El formato debe ser xxxxxxxxxxxxxx== donde x son letras, números y símbolos.",
  input_error_not_terms: "Debes aceptar nuestros términos y condiciones",
  error_login_credentials: "Revisa tu usuario o contraseña.",
  successful_deletion_message: "Se ha borrado correctamente.",
  successful_disabled_message: "Se ha desactivado correctamente.",
  successful_active_message: "Se ha activado correctamente.",
  successful_create_message: "Se ha creado correctamente.",
  successful_update_message: "Se ha actualizado correctamente.",
  error_token_message:
    "Se ha producido un error debido a la inexistencia o uso previo del token. Por favor, genera un nuevo token para continuar.",
  input_optional_label: "(opcional)",
  input_show_password_label: "Mostrar contraseña",
  input_hide_password_label: "Ocultar contraseña",
  input_search_placeholder: "Buscar",
  input_phone_number_placeholder: "Ingresa tu número de teléfono",
  input_phone_number_label: "Número de teléfono",
  not_found_message: "No se encontraron resultados",
  input_phone_label: "Télefono",
  input_phone_placeholder: "Ingresa el número de télefono",
  input_date_placeholder: "Selecciona una fecha",
  sidebar_settings_label: "Ajustes",
  sidebar_section_billeteras: "Billeteras",
  sidebar_section_operaciones: "Operaciones",
  sidebar_section_analitica: "Analítica",
  sidebar_section_gestion: "Gestión",
  sidebar_section_tarjetas: "Tarjetas",
  sidebar_menu_wallets_home: "Billeteras",
  sidebar_menu_wallets: "Wallets",
  sidebar_menu_payouts: "Enviar dinero",
  sidebar_menu_breb_qr_pay: "Pagar con QR",
  sidebar_menu_payout_batches: "Pagos por lote",
  sidebar_menu_holders: "Titulares",
  sidebar_menu_pockets: "Bolsillos",
  sidebar_menu_confirmations: "Confirmaciones",
  sidebar_menu_payments: "Solicitudes de pagos",
  sidebar_menu_payout_rescue: "Rescate de dispersiones",
  sidebar_menu_swaps: "Swaps",
  sidebar_menu_audit: "Auditoría",
  sidebar_menu_accounts_tracking: "Seguimiento de cuentas",
  sidebar_menu_payins: "Recibir dinero",
  sidebar_menu_payments_activity: "Actividad",
  sidebar_menu_payments_notifications: "Notificaciones",
  sidebar_menu_crypto_swaps_group: "Cripto",
  sidebar_menu_crypto_swaps: "Comprar USDT",
  sidebar_menu_crypto_sell: "Vender USDT",
  sidebar_menu_crypto_swaps_history: "Historial",
  sidebar_menu_payments_ledger: "Libro contable",
  sidebar_menu_account_verification: "Verificación de cuentas",
  sidebar_menu_cardholder_onboarding: "Alta de titulares",
  sidebar_menu_cards: "Tarjetas",
  sidebar_menu_cards_notifications: "Notificaciones",
  sidebar_menu_routes_countries: "Rutas y países",
  sidebar_menu_organizations: "Organizaciones",
  sidebar_menu_wallet_top_ups: "Cargas a billeteras",
  sidebar_menu_wallet_debits: "Descargas de billeteras",
  sidebar_menu_card_wallets: "Billetera de tarjetas",
  sidebar_menu_internal_api_keys: "Llaves internas",
  sidebar_menu_payment_rails: "Rieles de pago",
  sidebar_menu_payment_limits: "Límites de monto",
  sidebar_menu_rate_providers: "Proveedores de tasas",
  sidebar_menu_metrics: "Métricas",
  sidebar_menu_payment_routes: "Corredores y proveedores",
  sidebar_menu_payment_fees: "Tarifas y comisiones",
  sidebar_menu_payment_taxes: "Impuestos",

  sidebar_menu_deposit_clabes: "CLABEs de depósito",
  sidebar_menu_deposit_cvus: "CVUs de depósito",
  sidebar_menu_quoter: "Cotizador",
  sidebar_menu_quoter_coloca: "Cotizador Coloca",
  sidebar_menu_news: "Novedades",
  no_access_title: "Ups, no tienes permiso",
  no_access_description:
    "No tienes permiso para acceder a esta sección. Si crees que deberías poder verla, contacta al administrador de tu cuenta.",
  no_access_back_home: "Volver al inicio",
  no_navigation_access_title: "Tu cuenta aún no tiene accesos",
  no_navigation_access_description:
    "Todavía no se te ha asignado ningún acceso. Contacta al administrador de tu organización para que te habilite lo que necesitas.",
  sidebar_menu_users: "Usuarios",
  sidebar_menu_clients: "Clientes",
  sidebar_menu_api_keys: "Claves de API",
  sidebar_menu_roles: "Roles",
  sidebar_menu_policies: "Políticas",
  loading_button: "Cargando...",
  pagination_records: "Registros del {{from}} al {{to}} de {{total}}",
  pagination_empty: "Sin registros",
  pagination_total_pages: "Total de páginas ({{lastPage}})",
  pagination_first_page: "Primera página",
  pagination_prev_page: "Página anterior",
  pagination_next_page: "Página siguiente",
  pagination_last_page: "Última página",
  modal_confirm_button: "Confirmar",
  modal_cancel_button: "Cancelar",
  phone_field_select_country_placeholder: "Selecciona un país primero",
  phone_field_search_country_placeholder: "Buscar país…",
  nav_user_account: "Cuenta",
  nav_user_settings: "Configuración",
  nav_user_logout: "Cerrar sesión",
  nav_user_organization: "Organización",
  nav_user_install_app: "Instalar app",
  pwa_update_activated_elsewhere:
    "Hay una versión nueva de Coloca. Recarga esta pestaña cuando termines lo que estás haciendo.",
  pwa_reload_action: "Recargar",
  pwa_update_menu: "Actualizar a la versión nueva",
  pwa_install_title: "Instala Coloca",
  pwa_install_body: "Tenla en tu pantalla de inicio y ábrela sin buscar el enlace.",
  pwa_install_body_open_in_safari: "Para instalarla, abre esta página en Safari.",
  pwa_install_ios_step_share: "Toca <b>Compartir</b>",
  pwa_install_ios_step_share_hint: "Si no está en la barra, búscalo en •••",
  pwa_install_ios_step_add: "Elige <b>Agregar a inicio</b> y luego <b>Agregar</b>",
  pwa_install_action: "Instalar",
  pwa_install_later: "Ahora no",
  pwa_install_close: "Cerrar",
  pwa_install_copy_link: "Copiar enlace",
  pwa_install_link_copied: "Enlace copiado. Pégalo en Safari.",
  pwa_install_link_copied_short: "Copiado",
  pwa_install_copy_error: "No se pudo copiar el enlace.",
  header_notifications_title: "Notificaciones",
  header_notifications_empty: "No hay notificaciones",
  header_notifications_load_more: "Ver anteriores",
  header_notifications_mark_read_failed: "No se pudo marcar como leída. Inténtalo de nuevo.",
  pix_key_ph_cpf: "000.000.000-00",
  pix_key_helper_cpf: "11 dígitos, sin puntos ni guiones.",
  pix_key_err_cpf: "El CPF debe tener 11 dígitos.",
  pix_key_ph_cnpj: "00.000.000/0000-00",
  pix_key_helper_cnpj: "14 dígitos, sin puntos ni guiones.",
  pix_key_err_cnpj: "El CNPJ debe tener 14 dígitos.",
  pix_key_ph_email: "nombre@dominio.com",
  pix_key_helper_email: "Correo en minúsculas, p. ej. nombre@dominio.com.",
  pix_key_err_email: "Ingresa un correo válido en minúsculas.",
  pix_key_ph_phone: "(11) 98765-4321",
  pix_key_helper_phone: "Número con código de área, hasta 11 dígitos.",
  pix_key_err_phone: "El teléfono debe tener 10 u 11 dígitos.",
  pix_key_ph_evp: "123e4567-e89b-12d3-a456-426614174000",
  pix_key_helper_evp: "Pega la clave aleatoria (formato UUID).",
  pix_key_err_evp: "La clave debe tener formato UUID.",
  route_error_title: "Ocurrió un error inesperado",
  route_error_description: "La pantalla no se pudo mostrar. Recarga la página para continuar donde estabas.",
  route_error_reload: "Recargar la página",
  country_ARG: "Argentina",
  country_BRA: "Brasil",
  country_CHL: "Chile",
  country_COL: "Colombia",
  country_MEX: "México",
  country_PER: "Perú",
  subdivision_placeholder: "Busca un estado o departamento",
  subdivision_empty: "Sin resultados",
  amount_hidden: "Monto oculto",
  security_pin_step_label: "Paso {{step}} de {{total}}",
  security_pin_step_create_title: "Elige tu PIN de 6 dígitos",
  security_pin_step_create_hint: "Evita fechas, números repetidos o seguidos.",
  security_pin_step_confirm_title: "Escríbelo otra vez",
  security_pin_step_confirm_hint: "Para asegurarnos de que lo recuerdas.",
  security_pin_step_password_title: "Confirma que eres tú",
  security_pin_step_password_hint:
    "Escribe la contraseña con la que inicias sesión. Así nadie puede crear un PIN con tu sesión abierta.",
  security_pin_password_label: "Contraseña",
  security_pin_password_show: "Mostrar contraseña",
  security_pin_password_hide: "Ocultar contraseña",
  security_pin_password_required: "Escribe tu contraseña.",
  security_pin_show: "Mostrar PIN",
  security_pin_hide: "Ocultar PIN",
  security_pin_issue_repeated: "No uses el mismo número seis veces.",
  security_pin_issue_sequence: "Evita números seguidos, como 123456 o 654321.",
  security_pin_issue_pattern:
    "Evita patrones fáciles de adivinar, como 121212, 112233, 123321 o líneas del teclado.",
  security_pin_issue_common: "Ese PIN es muy común. Elige otro.",
  security_pin_strength_ok: "Buen PIN",
  security_pin_mismatch: "No coincide con el PIN que elegiste. Escríbelo otra vez.",
  security_pin_next: "Continuar",
  security_pin_back: "Atrás",
  security_pin_submit_create: "Crear PIN",
  security_pin_submit_create_continue: "Crear PIN y continuar",
  security_pin_submit_change: "Guardar PIN nuevo",
  security_pin_done_title: "Tu PIN está listo",
  security_pin_done_body: "Te lo pediremos para acciones sensibles, como crear tarjetas o mover dinero.",
  security_pin_done_email_backup:
    "Respaldo por email activado: si olvidas tu PIN, te enviamos un código a tu correo.",
  security_pin_done_body_continue: "Ahora confirma la acción con tu PIN nuevo.",
  security_pin_done_body_challenge: "Vuelve y escribe tu PIN nuevo para confirmar.",
  security_pin_done_continue: "Continuar",
  security_pin_done_close: "Listo",
  security_pin_done_back_to_challenge: "Escribir mi PIN",
  security_pin_error_password: "La contraseña no es correcta.",
  security_pin_error_generic: "No pudimos guardar tu PIN. Inténtalo de nuevo.",
  security_pin_dialog_create_title: "Crea tu PIN de seguridad",
  security_pin_dialog_change_title: "Cambiar PIN de seguridad",
  security_pin_dialog_reset_title: "Crea un PIN nuevo",
  security_pin_dialog_description: "Seis dígitos que confirmarán tus acciones sensibles.",
  step_up_required_title: "Protege esta acción",
  step_up_choice_totp_name: "App autenticadora",
  step_up_choice_totp_badge: "Recomendado · Más seguro",
  step_up_choice_totp_body:
    "Google Authenticator, Authy o similar te da un código nuevo cada 30 segundos. Aunque alguien sepa tu contraseña, sin tu celular no puede confirmar nada.",
  step_up_choice_totp_time: "≈ 3 min, en Configuración",
  step_up_choice_pin_name: "PIN de seguridad",
  step_up_choice_pin_badge: "Más rápido",
  step_up_choice_pin_body:
    "Seis dígitos que tú eliges. Lo creas aquí mismo y sigues con lo que estabas haciendo. Es menos seguro que la app, porque es algo que sabes y no algo que tienes.",
  step_up_choice_pin_time: "≈ 1 min, aquí mismo",
  step_up_choice_footnote:
    "Puedes empezar con el PIN y pasarte a la app cuando quieras: al activarla, reemplaza al PIN.",
  step_up_choice_go_totp: "Configurar la app",
  step_up_choice_create_pin: "Crear PIN",
  step_up_meter_security: "Seguridad",
  step_up_meter_speed: "Rapidez",
  two_factor_challenge_pin_title: "Escribe tu PIN de seguridad",
  two_factor_challenge_pin_description: "Los 6 dígitos que elegiste para confirmar acciones sensibles.",
  two_factor_challenge_pin_forgot: "¿Olvidaste tu PIN? Crea uno nuevo",
  two_factor_challenge_pin_locked_title: "Tu PIN está bloqueado",
  two_factor_challenge_pin_locked:
    "Hubo demasiados intentos fallidos. Podrás intentarlo de nuevo en {{time}}, o crea un PIN nuevo ahora con tu contraseña.",
  two_factor_challenge_pin_reset_required:
    "Se bloqueó por demasiados intentos fallidos. Crea un PIN nuevo con tu contraseña para continuar.",
  two_factor_challenge_pin_new: "Crear PIN nuevo",
  reauth_password_incorrect_hint:
    "La contraseña no es correcta. Tras 5 intentos fallidos bloqueamos tu cuenta durante 30 minutos.",
  security_pin_error_reused: "El PIN nuevo debe ser distinto al actual.",
  security_pin_issue_date: "Parece una fecha, como un cumpleaños: es de lo primero que alguien intentaría.",
  security_pin_issue_phone: "Está dentro de tu número de celular. Elige otro.",
  two_factor_challenge_totp_locked_title: "Verificación en pausa",
  two_factor_challenge_totp_locked:
    "Hubo 5 códigos incorrectos seguidos. Podrás intentarlo de nuevo en {{time}}.",
  step_up_sessions_revoked:
    "Por seguridad bloqueamos tu PIN y cerramos tus sesiones. Inicia sesión y crea un PIN nuevo en Configuración → Seguridad.",
  step_up_email_offer_pin: "¿No tienes tu PIN a mano?",
  step_up_email_offer_totp: "¿No tienes tu celular a mano?",
  step_up_email_offer_action: "Recibir un código por email",
  step_up_email_sending: "Enviando el código…",
  step_up_email_title: "Revisa tu correo",
  step_up_email_description_fallback:
    "Te enviamos un código de 6 dígitos a tu correo. Vence en 10 minutos y solo sirve para esta acción.",
  step_up_email_code_label: "Código que te enviamos por email",
  step_up_email_spam_hint: "¿No llega? Revisa la carpeta de spam o pide otro código.",
  step_up_email_resend: "Reenviar código",
  step_up_email_resend_in: "Reenviar en {{time}}",
  step_up_email_resent: "Te enviamos un código nuevo. El anterior ya no sirve.",
  step_up_email_back_pin: "Volver a mi PIN",
  step_up_email_back_totp: "Volver a mi app",
  step_up_email_code_invalid:
    "Este código ya no sirve: venció, ya se usó o tuvo demasiados intentos. Pide uno nuevo.",
  step_up_email_not_enabled:
    "El respaldo por email está desactivado. Puedes activarlo en Configuración → Seguridad.",
  step_up_email_error_generic: "No pudimos enviar el código. Inténtalo de nuevo en un momento.",
  step_up_choice_pin_email_note: "Incluye respaldo por email",
  step_up_choice_totp_email_note: "Respaldo por email opcional",
  step_up_email_backup_error_requires_method:
    "Primero elige la app autenticadora o un PIN: el respaldo por email es el plan B de ese método.",
  step_up_email_backup_error_not_available: "El respaldo por email no está disponible para tu cuenta.",
  step_up_email_backup_error_generic: "No pudimos guardar el cambio. Inténtalo de nuevo.",
  tax_transaction_cost: "Costo de transacción",
};
